import React, { useEffect, useRef, useState } from "react";
import "./FormDetail.scss";
import UploadIcon from "../../assets/Vector.png";
import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";
import axios from "axios";
import uploadToS3 from "../../utility/uploadToS3";

import { Loader } from "@classplus-engineering/components";

import Tick from "../../assets/1stPayment.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { API } from "../../config/api";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
	"& .MuiInputBase-input": {
		position: "relative",
		backgroundColor: "white",
		border: "1px solid #ced4da",
		fontSize: 16,
		padding: "10px 26px 10px 12px",
		transition: theme.transitions.create(["border-color", "box-shadow"]),
		fontFamily: ["Lato"].join(","),
		"&:focus": {
			borderColor: "#80bdff",
		},
	},
}));

const FormDetail = (props) => {
	const uploadRef = useRef("");
	const [JobDescription, setJobDescription] = useState([]);
	const [IsLoading, setIsLoading] = useState(false);
	const [uploading, setUploading] = useState(false);

	const utmData = useSelector((state) => state.OtherData.utmData);
	const referralUserName = useSelector(
		(state) => state.OtherData.referralUserName
	);

	const searchParam = props.history.location.search;
	const urlParams = new URLSearchParams(searchParam);
	const jobId = urlParams.get("jobId");
	const [applicationSubmitted, setApplicationSubmitted] = useState(false);
	const [finalImageUrl, setFinalImageUrl] = useState("");
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		if (uploading) {
		}
	}, [uploading]);
	useEffect(() => {
		async function getJD() {
			try {
				setIsLoading(true);
				const response = await axios.get(
					`https://crm.classplus.co/ts/jobs/get-job-description?jobId=${jobId}`
				);

				const data = response.data.data;
				setJobDescription(data.JobDescription);

				setIsLoading(false);
			} catch (error) {
				setIsLoading(false);
				console.error(error.message);
			}
		}

		getJD();
	}, [searchParam, jobId]);
	const [leadType, setLeadType] = useState("");
	const [sourceIsTouched, setSourceIsTouched] = useState(false);
	const [name, setName] = useState("");
	const [nameIsTouched, setNameIsTouched] = useState(false);
	const [email, setEmail] = useState("");
	const [emailIsTouched, setEmailIsTouched] = useState(false);
	const [mobile, setMobile] = useState("");
	const [mobileIsTouched, setMobileIsTouched] = useState(false);
	const [linkedin, setLinkedin] = useState("");
	const [portfolio, setPortfolio] = useState("");
	const [fileName, setFileName] = useState("Upload Resume");

	let finalImageUrlIsValid = finalImageUrl !== "";

	let nameIsValid = name.trim() !== "" && name.trim().length > 3;
	let nameIsInvalid = !nameIsValid && nameIsTouched;

	let emailRegex =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	let emailIsValid = email.trim() !== "" && emailRegex.test(email);
	let emailIsInvalid = !emailIsValid && emailIsTouched;

	let mobileRegex = /^([+]\d{2})?\d{10}$/;
	let mobileIsValid = mobile.trim() !== "" && mobileRegex.test(mobile);
	let mobileIsInvalid = !mobileIsValid && mobileIsTouched;

	let sourceIsValid = leadType !== "";
	let sourceIsInvalid = !sourceIsValid && sourceIsTouched;

	let formIsValid = false;
	formIsValid =
		nameIsValid && emailIsValid && mobileIsValid && finalImageUrlIsValid && sourceIsValid;

	const nameHandler = (e) => {
		setName(e.target.value);
	};

	const onNameBlurHandler = () => {
		setNameIsTouched(true);
	};

	const emailHandler = (e) => {
		setEmail(e.target.value);
	};
	const onEmailBlurHandler = (e) => {
		setEmailIsTouched(true);
	};

	const mobileHandler = (e) => {
		setMobile(e.target.value);
	};

	const onMobileBlurHandler = (e) => {
		setMobileIsTouched(true);
	};
	const linkedinHandler = (e) => {
		setLinkedin(e.target.value);
	};
	const portfolioHandler = (e) => {
		setPortfolio(e.target.value);
	};

	const onSourceBlurHandler = (e) => {
		setSourceIsTouched(true);
	};

	const handleChange = (event) => {
		setLeadType(event.target.value);
	};

	const submitHandler = async (e) => {
		e.preventDefault();

		const applicationDetails = {
			resumeURL: finalImageUrl,
			fullName: name,
			email: email,
			mobileNumber: mobile,
			linkedIn: linkedin ? linkedin : null,
			portfolioLink: portfolio ? portfolio : null,
			leadType: leadType ? leadType : null,
			jobId: jobId,
			utmSource: utmData[0] ? utmData[0].utm_source : null,
			utmMedium: utmData[0] ? utmData[0].utm_medium : null,
			utmCampaign: utmData[0] ? utmData[0].utm_campaign : null,
			referral_username: referralUserName ? referralUserName : null,
		};

		if (!applicationDetails.resumeURL) {
			throw new Error("please upload resume again");
		}
		try {
			const response = await axios.post(API.PROD, applicationDetails);
			setApplicationSubmitted(response.data.message);
		} catch (err) {
			console.log(err.message);
		}
		window.scrollTo(0, 0);
	};

	const fileUploadHandler = (e) => {
		var reader = new FileReader();

		function dataURItoBlob(dataURI) {
			var binary = atob(dataURI.split(",")[1]);
			var array = [];
			for (var i = 0; i < binary.length; i++) {
				array.push(binary.charCodeAt(i));
			}
			return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
		}

		if (e.target.files[0]) {
			reader.readAsDataURL(e.target.files[0]);
			let name = e.target.files[0].name;
			reader.onload = async (e) => {
				setLoader(true);
				setFileName(name);
				let blob = dataURItoBlob(reader.result);
				blob.name = name;
				await uploadToS3([blob]).then((res) => {
					setFinalImageUrl(res[0].url);
				});
			};
			setUploading(true);
			setIsLoading(false);
			setLoader(false);
		}
	};

	let jobTitle;

	if (IsLoading) {
		jobTitle = <Loader />;
	}

	if (
		JobDescription.designation &&
		JobDescription.locationCity &&
		JobDescription.parentDepartment &&
		JobDescription.employeeType &&
		JobDescription.experienceFrom &&
		JobDescription.experienceTo
	) {
		jobTitle = (
			<>
				<h3>
					{JobDescription.designation} ({JobDescription.experienceFrom} -{" "}
					{JobDescription.experienceTo} years)
				</h3>
				<p>{`${JobDescription.locationCity} NCR / ${JobDescription.parentDepartment} / ${JobDescription.employeeType}`}</p>
			</>
		);
	}

	let SuccessText;
	if (loader) {
		SuccessText = <Loader />;
	}
	if (finalImageUrl) {
		SuccessText = <span className='success'>Success</span>;
	}

	return (
		<div className='applyForJob'>
			<div className='applyForJob__position'>{jobTitle}</div>
			<div className='applyForJob__form'>
				{!applicationSubmitted ? (
					<form className='applyForJob__form__detail'>
						<h3>SUBMIT YOUR APPLICATION</h3>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='uploadBtn'>
								Resume/CV <span style={{ color: "red" }}>*</span>
							</label>
							<div className='applyForJob__form__detail__form-input--upload'>
								<button
									type='button'
									onClick={() => {
										uploadRef.current.click();
									}}
								>
									<span>
										<img src={UploadIcon} alt='uploadIcon' />
									</span>
									{fileName}
									<input
										type='file'
										accept='application/pdf'
										id='uploadBtn'
										onChange={fileUploadHandler}
										ref={uploadRef}
										style={{ display: "none" }}
									/>
								</button>
								{SuccessText}
							</div>
						</div>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='fullname'>
								Full Name <span style={{ color: "red" }}>*</span>
							</label>
							<input
								autoComplete='off'
								type='text'
								value={name}
								id='fullname'
								style={{
									border: nameIsInvalid && "1px solid red",
									background: nameIsInvalid && "#f7c5bf",
								}}
								onChange={nameHandler}
								onBlur={onNameBlurHandler}
							/>
						</div>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='email'>
								Email Address <span style={{ color: "red" }}>*</span>
							</label>
							<input
								autoComplete='off'
								type='email'
								value={email}
								id='email'
								style={{
									border: emailIsInvalid && "1px solid red",
									background: emailIsInvalid && "#f7c5bf",
								}}
								onChange={emailHandler}
								onBlur={onEmailBlurHandler}
							/>
						</div>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='mobile'>
								Mobile Number <span style={{ color: "red" }}>*</span>
							</label>
							<input
								autoComplete='off'
								type='text'
								maxLength='11'
								value={mobile}
								id='mobile'
								onChange={mobileHandler}
								style={{
									border: mobileIsInvalid && "1px solid red",
									background: mobileIsInvalid && "#f7c5bf",
								}}
								onBlur={onMobileBlurHandler}
							/>
						</div>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='linkedin'>Linkedin Profile</label>
							<input
								autoComplete='off'
								type='text'
								value={linkedin}
								id='linkedin'
								onChange={linkedinHandler}
							/>
						</div>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='portfolio'>Portfolio Link</label>
							<input
								autoComplete='off'
								type='text'
								value={portfolio}
								id='portfolio'
								onChange={portfolioHandler}
							/>
						</div>
						<div className='applyForJob__form__detail__form-input'>
							<label htmlFor='demo-customized-select-native'>
								Where did you hear about us?{" "}<span style={{ color: "red" }}>*</span>
							</label>
							<FormControl sx={{ m: 1 }} variant='standard'>
								<NativeSelect
									id='demo-customized-select-native'
									value={leadType}
									onChange={handleChange}
									onBlur={onSourceBlurHandler}
									input={<BootstrapInput />}
									style={{
										border: sourceIsInvalid && "1px solid red",
										background: sourceIsInvalid && "#f7c5bf",
									}}
								>
									<option aria-label='None' value='' />
									<option value={"Linkedin"}>Linkedin</option>
									<option value={"Medium"}>Medium</option>
									<option value={"Instagram"}>Instagram</option>
									<option value={"Youtube"}>Youtube</option>
									<option value={"News Articles"}>News Articles</option>
									<option value={"Twitter"}>Twitter</option>
									<option value={"Word of mouth"}>Word of mouth</option>
									<option value={"Job Portals"}>Job Portals</option>
								</NativeSelect>
							</FormControl>
						</div>
						<hr className='hr' />
						<div
							id='submit'
							className={`applyForJob__form__detail__form-input--submit ${
								!formIsValid && "disabledError"
							}`}
							onClick={(e) => formIsValid && submitHandler(e)}
						>
							Submit
						</div>
					</form>
				) : (
					<div className='applyForJob__form__submitted'>
						<img src={Tick} alt='tick' />
						<h3 className='applyForJob__form__submitted__text'>
							Application Submitted!
						</h3>
						<hr className='hr' />
						<Link to='/'>
							<div className='applyForJob__form__submitted__button'>
								RETURN TO MAIN PAGE
							</div>
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default FormDetail;
